export const environment = {
  production: false,
  apiUrl: 'https://dev.codideep.com/api',
  MAX_INACTIVE_MINUTES: 10080,
  WARNING_TIME_SECONDS: 30,
  REFRESH_INTERVAL_MINUTES: 60,
  recaptchaSiteKey: '6LcUwHMaAAAAAIUn-5HQ25qU1FhSR4zUVoGmqOvt',
};
